import React from 'react';

interface LandingSectionHeadProps {
  eyebrow: string;
  title: string;
  lead?: string;
  centered?: boolean;
}

const LandingSectionHead: React.FC<LandingSectionHeadProps> = ({
  eyebrow,
  title,
  lead,
  centered = false,
}) => (
  <header
    className={`cp-landing-section-head${centered ? ' cp-landing-section-head--center' : ''}`}
  >
    <span className="cp-landing-eyebrow">{eyebrow}</span>
    <h2 className="cp-landing-section-title">{title}</h2>
    {lead ? <p className="cp-landing-section-lead">{lead}</p> : null}
  </header>
);

export default LandingSectionHead;
